module.exports = __webpack_public_path__ + "img/green_025.15ca7c8e.png";